<template>
    <div class="iii" :value="showLoding" :style="{display:showLoding ? 'none':'block'}">
      <Spin :fix='true' size="large">
          <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
      </Spin>
    </div>

</template>
<script>
/**
 * 加载弹框
 * @param showLoding boolean 

 * @param fn function 回调函数
 */
    export default {
        props:{
            showLoding: Boolean,
        },
        components: {
        },
        name: "Model2",
        data () {
            return{
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
.demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }
    .iii{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99999999999999999;
        }

   .ivu-spin-fix {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 8;
      width: 100%;
      height: 100%;
      background-color: rgba(45, 45, 45, 0);
  }
</style>

